import React from 'react';
import { useRefreshOutlookAuth } from '../../services/react-query/integrations/outlook_calendar/useRefreshOutlookAuth';
import { Integration } from '../../types/Integration';
import CalendarIntegrationCard from './CalendarIntegrationCard';

interface OutlookCalendarIntegrationProps {
  integration?: Integration;
  isLoading?: boolean;
}

export default function OutlookCalendarIntegration({ integration, isLoading = false }: OutlookCalendarIntegrationProps) {
  const { mutate: refreshOutlookAuth } = useRefreshOutlookAuth();

  const isSynced = !!integration?.enabled;

  return (
    <CalendarIntegrationCard
      label="Outlook Calendar"
      logoSrc="/svg/outlook_calendar.svg"
      isSynced={isSynced}
      onConnect={refreshOutlookAuth}
      isLoading={isLoading}
    />
  );
}
